import { ReactElement } from 'react';
import { Button, ButtonProps } from 'common/components/antd/Button/Button';
import { ReactComponent as Swap } from 'assets/ibm/arrows--vertical.svg';

export const SwapButton = (props: ButtonProps): ReactElement => (
  <Button
    style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    }}
    type="text"
    icon={<Swap />}
    {...props}
  />
);
